import React from 'react'
import moment from 'moment'
import { Modal, Status } from '@iqueue/ui-kit'
import { DevEUIFormatter } from '../pages/sensor/SensorsPage'
import { t } from '../hooks/useTranslate'

export function convertSecondsToDaysAndHours(seconds) {
  const days = Math.floor(seconds / (24 * 3600))
  const hours = Math.floor((seconds % (24 * 3600)) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  return [
    days > 0 ? `${ days } д` : '',
    hours > 0 ? `${ hours } ч` : '',
    minutes > 0 ? `${ minutes } м` : '',
    `${ secs } с`,
  ].filter(part => part).join(' ')
}

export default function SensorInfoModal({ isOpened, title, onClose, footerActions, currentSensor, valueRenderer }) {
  return <Modal
    isOpened={ isOpened }
    title={ title }
    onClose={ onClose }
    footerActions={ footerActions }
  >
    <div className="sensor-info-container">
      <div className="sensor-info-group-title">{ t('sensorInfo.lastData') }</div>
      <div className="sensor-info-group last-value-sensor">
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.lastReading') }</span>
          <b className="sensor-info-value">
            { valueRenderer(Number(currentSensor?.state?.value).toFixed(2)) }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.lastEventAt') }</span>
          <b className="sensor-info-value">
            { currentSensor?.state?.createdAt
              ? moment().format('DD.MM.YYYY HH:mm')
              : t('sensorInfo.noData') }
          </b>
        </div>
      </div>

      <div className="sensor-info-group">
        <div className="sensor-info-group-title">{ t('sensorInfo.sensorState') }</div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.interval') }</span>
          <b className="sensor-info-value">
            { currentSensor?.state?.interval
              ? `${ Math.floor(currentSensor.state.interval / 60) } мин`
              : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.voltage') }</span>
          <b className="sensor-info-value">
            { currentSensor?.state?.voltage
              ? `${ (currentSensor.state.voltage / 1000).toFixed(2) } V`
              : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.uptime') }</span>
          <b className="sensor-info-value">
            { currentSensor?.state?.uptime
              ? convertSecondsToDaysAndHours(currentSensor.state.uptime)
              : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.sensorStatus') }</span>
          <b className="sensor-info-value">
            { currentSensor?.state
              ? <Status
                style={ { marginTop: '0.8rem' } }
                inline={ currentSensor.status !== 'NO_SIGNAL' }
                weak
                warning={ currentSensor.status === 'TECH_WORKS' }
                error={ currentSensor.status === 'NO_SIGNAL' || currentSensor.status === 'SHORT_CIRCUIT' || currentSensor.status === 'NO_SENSOR_SIGNAL' || currentSensor.status === 'UNKNOWN_UNIT' || currentSensor.status === 'INVALID_DRIVER' }
              >
                { t(`status.sensor.${ currentSensor.status }`) }
              </Status>
              : t('sensorInfo.noData') }
          </b>
        </div>
      </div>

      <div className="sensor-info-group">
        <div className="sensor-info-group-title">{ t('sensorInfo.mainInfo') }</div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.devEUI') }</span>
          <b className="sensor-info-value">
            { currentSensor?.devEUI ? <DevEUIFormatter devEUI={ currentSensor?.devEUI }/> : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.createdAt') }</span>
          <b className="sensor-info-value">
            { currentSensor?.state?.createdAt
              ? moment(currentSensor.state.createdAt).format('DD.MM.YYYY HH:mm')
              : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.serialNumber') }</span>
          <b className="sensor-info-value">
            { currentSensor?.serialNumber ? `${ currentSensor.serialNumber }` : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.fabricator') }</span>
          <b className="sensor-info-value">
            { currentSensor?.model?.fabricator?.name ? `${ currentSensor.model.fabricator.name }` : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.verificationDate') }</span>
          <b className="sensor-info-value">
            { currentSensor?.verification?.verifiedAt
              ? moment(currentSensor.verification.verifiedAt).format('DD.MM.YYYY')
              : t('sensorInfo.noData') }
          </b>
        </div>
        <div className="sensor-info-block">
          <span className="sensor-info-label">{ t('sensorInfo.verificationExpire') }</span>
          <b className="sensor-info-value">
            { currentSensor?.verification?.expireAt
              ? moment(currentSensor.verification.expireAt).format('DD.MM.YYYY')
              : t('sensorInfo.noData') }
          </b>
        </div>
      </div>

    </div>

  </Modal>
}
